export let publicAccessType = "tUmtnb";
export default {publicAccessType};